<template>
    <div class="content">
        <div class="container">
            <!-- title -->
            <div class="row ki_block_title">
                <div class="col-12">
                    <h1 class="title mt_sm">Корзина</h1>
                </div>
            </div>
            <!-- // title -->

            <!-- cart_block -->
            <div v-if="items.length" class="row cart_block mt_sm">
                <div class="col-12">
                    <div class="header_block">

                        <div class="header_block_message">
                            В корзине <strong>{{ qty }}</strong> на сумму <strong>{{ amount }} руб.</strong>
                            <tamplete v-if="unavailableQty > 0">
                                Для <strong>{{ unavailableQty }} позиций</strong> недостаточно запасов на складе.
                            </tamplete>
                        </div>

                        <form action="/cart/empty" method="get">
                            <button class="btn btn_sm btn_neutral">Очистить корзину</button>
                        </form>

                        <form action="/cart/export" method="get">
                            <button class="btn btn_sm btn_neutral">Экспорт в файл</button>
                        </form>
                    </div>
                </div>
            </div>
            <!-- //cart_block -->

            <template v-for="(group, groupIndex) in groups">
                <!-- cart_block -->
                <div v-if="parseInt(groupIndex)" class="row cart_block mt_sm">
                    <div class="col-12">
                        <div class="info_title cart_group_title">
                            Данные изделия являются частью комплекта. <b>Полный комплект</b> состоит из нескольких частей,
                            напр. (А), (B), (С) и (D). Для установки комплекта частей нужен <b>комплект пуансонов</b>, напр.
                            [А], [B], [С] и [D]. <a href="/complects">Справка о комплектах</a>
                        </div>
                    </div>
                </div>
                <!-- //cart_block -->

                <template v-for="(item, index) in group">
                    <!-- cart_item -->
                    <cart-item v-bind:item="item" v-bind:set="item.set_id"></cart-item>
                    <!-- //cart_item -->
                </template>
            </template>


            <div v-if="!items.length" class="row">
                <div class="col-12 mt_md">

                    <div class="box">
                        <div class="title">Положите товары в корзину</div>
                        <div class="text mt_xs">
                            <p>Чтобы оформить заказ, в корзине должны находиться товары</p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    methods: {
    },
    computed: {
        items() {
            return this.$store.state.cart.items;
        },
        groups() {
            console.log(this.$store.state.cart.groups);
            return this.$store.state.cart.groups;
        },
        qty() {
            let qty = this.$store.getters['cart/qty'];

            switch (qty % 10) {
                case 1: return qty + ' позиция';
                case 2:
                case 3:
                case 4: return qty + ' позиции';
                default:  return qty + ' позиций';
            }
        },
        amount() {
            return parseFloat(this.$store.state.cart.amount).toFixed(2);
        },
        unavailableQty() {
            return 0;
        }
    },
};
</script>
